import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AddCustomerAddress, CreateCustomer, Customer, CustomerContact, SearchCustoemrRoot, SearchCustomerResponse } from '../domain/Customer';
import { Address } from '../domain/Address';
import { ClientService } from './client.service';
import { BehaviorSubject, map, of } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  CustomerNos = new Array<SimplyKeyValueList>();
  Customers$ = new BehaviorSubject<Customer[]>(new Array<Customer>());
  constructor(private httpClient: HttpClient, private client: ClientService) { }

  getCustomers() {
    let thingy = this.httpClient.get<any>(`${environment.apiUrl}/e/customers/getByClient?clientId=${this.client.clientId}`);
    thingy.subscribe(x => {
      this.CustomerNos = x.items.map(c => { return { id: c.id, customerNo: c.customerNo } as SimplyKeyValueList });
      this.Customers$.next(x.items.sort((a, b) => a.name.localeCompare(b.name)));      
    }
    );
    return thingy;
  }

  create(customer: CreateCustomer) {
    return this.createCustomerWithAddrese(customer);
    return this.httpClient.post(`${environment.apiUrl}/customers/create`, customer); // pionts to online-book bff
  }
  createCustomerWithAddrese(customer: CreateCustomer) {
    customer.clientId = this.client.clientId;
    return this.httpClient.post(`${environment.apiUrl}/e/customers/create`, customer) // pionts to clientService via online-book bff
  }

  delete(customerId: any) {
    return this.deleteViaClientService(customerId);
    return this.httpClient.post(`${environment.apiUrl}/customers/delete`, { id: customerId });
  }

  deleteViaClientService(customerId: string) {
    return this.httpClient.post(`${environment.apiUrl}/e/customers/delete`, { id: customerId });
  }

  updateCustomer(customer: UpdateCustomer) {
    return this.UpdateCustomerViaClientService(customer)
    var updateCustomerCommand = {
      id: customer.id,
      name: customer.name,
      customerNo: customer.customerNo,
      note: customer.note,
    };

    return this.httpClient.post(`${environment.apiUrl}/customers/update`, updateCustomerCommand);
  }
  UpdateCustomerViaClientService(customer: UpdateCustomer) {
    return this.httpClient.post(`${environment.apiUrl}/e/customers/update`, customer);
  }

  searchCustomerFormatted(searchInput: string) {
    return this.httpClient.post<SearchCustoemrRoot>(`${environment.apiUrl}/customers/search`, { searchInput })
    .pipe(
      map(result => {
        let res = new Array();
        if (result && result.items) {

          for (let i = 0; i < result.items.length; i++) {            
            if (result.items[i].addresses.length > 0) {
              for (let j = 0; j < result.items[i].addresses.length; j++) {
                res.push({
                  id: result.items[i].id,
                  name: result.items[i].name,
                  address: result.items[i].addresses[j],
                  contactPersons: result.items[i].contactPersons,
                  note: result.items[i].note,
                  serviceCodes:result.items[i].serviceCodes                  
                });
                for (let k = 0; k < result.items[i].contactPersons.length; k++) {
                  res.push({
                    id: result.items[i].id,
                    name: result.items[i].name,
                    contactPerson: result.items[i].contactPersons[k],
                    address: result.items[i].addresses[j],
                    contactPersons: result.items[i].contactPersons,
                    note: result.items[i].note,
                    serviceCodes:result.items[i].serviceCodes
                  });
                }
              }
            }
          }
        }
        return res;
      })
    );
  }

  addAddress(address: AddCustomerAddress) {
    return this.httpClient.post(`${environment.apiUrl}/e/customer/addresses/add`, address);
    return this.httpClient.post(`${environment.apiUrl}/e/customer/address/add`, address);
  }

  updateCustomerAddress(address: Address, customerId: any) {
    var updateAddressCommand = {
      address: address,
      customerId: customerId,
    };
    return this.httpClient.post(`${environment.apiUrl}/e/customers/updateaddress`, updateAddressCommand)
    // return this.httpClient.post(`${environment.apiUrl}/e/customers/address/update`, updateAddressCommand);
  }

  deleteAddress(addressId: string, customerId: string) {
    return this.httpClient.post(`${environment.apiUrl}/customers/address/delete`, { addressId, customerId });
  }

  addContactPerson(contact: CustomerContact, customerId: string) {
    return this.httpClient.post(`${environment.apiUrl}/customers/contactPersons/add`, { ...contact, customerId });
  }

  updateContactPerson(contactPerson: CustomerContact, customerId: string) {
    return this.httpClient.post(`${environment.apiUrl}/customers/contactPerson/update`, { contactPerson: contactPerson, customerId });
  }

  deleteContactPerson(contactId: string, customerId: string) {
    return this.httpClient.post(`${environment.apiUrl}/customers/contactPersons/delete`, { contactId, customerId });
  }

  exportCustomers(customersToExpoort: any) {
    let request: ExportCustomerRequest;
    request = { CientsToExport: customersToExpoort };
    return this.httpClient.post<ExportCustomerResponse>(`${environment.apiUrl}/customers/exportcustomercsv`, request);
  }
  createcustomerwithmulplecontacts(customerToCreateList: CreateMultpleCustomerRequest) {
    return this.httpClient.post<ExportCustomerResponse>(`${environment.apiUrl}/customers/createcustomerwithmulplecontacts`, customerToCreateList);
  }
}

interface ExportCustomerRequest {
  CientsToExport: CustomerRequestObject[];
}
interface CustomerRequestObject {
  id: string;
  customerNo: string;
  note: string;
  addressIds: string[];
  registrationNumber: string;// some call it CustomerName but we call it "registrationNumber"
  contactPersons: ContactPersonRequest[];

}
interface ContactPersonRequest {
  id: string;
  name: string;
  email: string;
  phone: string;
  sendLabel: string;
}
interface ExportCustomerResponse {
  customerDataCSV: string;
}

interface SimplyKeyValueList {
  id: string;
  customerNo: string;
}
export interface CreateMultpleCustomerRequest {
  CustomerToCreate: CreateCustomer[];
}
export interface UpdateCustomer {
  id: string,
  name: string,
  customerNo: string,
  note: string,
  registrationNumber: string,
  serviceCodes: string[] | null
}
// export interface CreationCustomerData {

//   customerNo: string;
//   name: string;
//   registrationNumber: string;
//   street: string;
//   city: string;
//   zipCode: string;
//   countryCode: string;
//   longitude: number;
//   latitude: number;
//   validationSource: string;
//   contactName: string;
//   contactEmail: string;
//   contactPhone: string;
//   addressIds: string[];
//   sendLabel: boolean;
// }